"use client";

import { cn } from "@/util";
import { useEffect, useRef } from "react";
import * as THREE from "three";

export const Halo = ({ className }: { className?: string }) => {
  const vantaRef = useRef<HTMLDivElement>(null);
  const effectRef = useRef<any>(null);

  useEffect(() => {
    if (typeof window === "undefined" || !vantaRef.current) return;

    (window as any).THREE = THREE;

    const script = document.createElement("script");
    script.src = "/vanta.halo.min.js";
    script.async = true;

    script.onload = () => {
      if (window.VANTA?.HALO) {
        effectRef.current = window.VANTA.HALO({
          el: vantaRef.current!,
          THREE,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          baseColor: 0x8c45ff,
          backgroundColor: 0x000000,
          amplitudeFactor: 3,
          size: 1.7,
          minHeight: 200,
          minWidth: 200,
        });
      }
    };

    script.onerror = () => console.error("❌ Failed to load vanta.halo.min.js");

    document.head.appendChild(script);

    return () => {
      if (effectRef.current) {
        effectRef.current.destroy();
        effectRef.current = null;
      }
    };
  }, []);

  return (
    <div className="pointer-events-none fixed inset-0 -z-10 w-full h-full overflow-hidden">
      <div
        ref={vantaRef}
        className={cn("absolute inset-0 opacity-50", className)}
      />
      <div className="absolute inset-0 bg-[url('/grain.avif')] opacity-50 mix-blend-overlay bg-repeat bg-[length:100px_100px]" />
      <div className="absolute bottom-0 w-full bg-gradient-to-b from-transparent to-black h-4" />
    </div>
  );
};
